// NOTE: This is a draft legal text. Review by a legal professional is recommended.
import LegalPage from "@/components/LegalPage";
import { LEGAL_VERSIONS } from "@/lib/legalVersions";

export default function ExplicitConsentEn() {
  return (
    <LegalPage
      lang="en"
      title="Explicit Consent"
      subtitle="Explicit consent form for the processing of special-category personal data, where applicable."
      lastUpdated="May 2026"
      version={LEGAL_VERSIONS.marketing}
      testid="consent-page-en"
    >
      <h2>1. Purpose of This Document</h2>
      <p>
        Under Turkish KVKK and similar regimes, the processing of certain data
        categories — for example, biometric data or precise location — may
        require <strong>explicit consent</strong>. This document explains how
        uSeen requests and records such consent if and when it becomes
        relevant to a feature.
      </p>

      <h2>2. When Explicit Consent Is Requested</h2>
      <p>
        uSeen currently does not process special-category personal data as
        part of its core service. If a future feature requires such data, you
        will be asked to opt in via a clear, separate consent screen.
      </p>

      <h2>3. Withdrawing Consent</h2>
      <p>
        You may withdraw your explicit consent at any time through your
        account settings or by contacting us. Withdrawal does not affect the
        lawfulness of processing that already happened before the withdrawal.
      </p>

      <h2>4. Record-Keeping</h2>
      <p>
        Consent records — including the timestamp and version of the consent
        text — are kept to demonstrate compliance and to honour your choices
        across sessions.
      </p>

      <h2>5. Contact</h2>
      <p>
        For questions about consent or to withdraw a previously given
        consent, contact us through the contact page.
      </p>
    </LegalPage>
  );
}
